<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <div
        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
      >
        <EmailDelayNoticeEditPageHeader />
        <EmailDelayNoticeEditPageForm :formData="formData" />
      </div>
    </div>
  </div>
</template>

<script>
import EmailDelayNoticeEditPageHeader from "@/components/ComponentModule/NoticeComponent/EmailDelayNoticeEditPageHeader";
import EmailDelayNoticeEditPageForm from "@/components/ComponentModule/NoticeComponent/EmailDelayNoticeEditPageForm";

export default {
  name: "NoticePage",
  data() {
    return { formData: { delayMessage: "" } };
  },
  components: {
    EmailDelayNoticeEditPageHeader,
    EmailDelayNoticeEditPageForm
  }
};
</script>
